export const createConfigSlice = () => ({
    config: {
        useModelBasedQuery: !!(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('USE_MODEL_BASED_QUERY')),
    },
});
